<!--
页面名称: baiduMapView.vue
页面描述: 该页面为展示地图周边
开发人员: Vikanong
开发时间: 2018-xx-xx
其他说明: XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
-->
<template>
  <div class=''>
    <el-row>
      <el-col :span="6">
        <el-tabs
          type="border-card"
          v-model="peripheryVal"
          @tab-click="handleClick"
        >
          <el-tab-pane
            :label="item.name"
            :value="item.name"
            :name="item.name"
            v-for="(item,idnex) in peripheryMenu"
            :key='idnex'
          >
            <el-tabs
              v-model="peripheryVal2"
              @tab-click="handleClick2"
            >
              <el-tab-pane
                :label="itm.name"
                :value="itm.name"
                :name="itm.name"
                v-for="(itm,ind) in item.list"
                :key='ind'
              >
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <div
            id="BMapresults"
            class="BMapresults"
          >
          </div>
        </el-tabs>
      </el-col>
      <el-col :span="18">
        <baidu-map
          class="bm-view"         
          @ready="handler"
        >
        <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
         <!-- <bm-circle :center="circlePath.center" :radius="circlePath.radius" stroke-color="red"   
         :stroke-opacity="0.5" :stroke-weight="1" :editing="true" fill-color="red" :fillOpacity="0.3"></bm-circle> -->
        </baidu-map>

      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  data() {
    return {
      //周边菜单
      peripheryMenu: [
        {
          name: "交通",
          val: "",
          list: [
            {
              name: "地铁",
              val: "",
              num: "1"
            },
            {
              name: "公交",
              val: "",
              num: "1"
            },
            {
              name: "车站",
              val: "",
              num: "1"
            }
          ]
        },
        {
          name: "教育",
          val: "",
          list: [
            {
              name: "幼儿园",
              val: "",
              num: "1"
            },
            {
              name: "小学",
              val: "",
              num: "1"
            },
            {
              name: "中学",
              val: "",
              num: "1"
            },
            {
              name: "大学",
              val: "",
              num: "1"
            }
          ]
        },
        {
          name: "医疗",
          val: "",
          list: [
            {
              name: "医院",
              val: "",
              num: "1"
            },
            {
              name: "药店",
              val: "",
              num: "1"
            }
          ]
        },
        {
          name: "购物",
          val: "",
          list: [
            {
              name: "商场",
              val: "",
              num: "1"
            },
            {
              name: "超市",
              val: "",
              num: "1"
            },
            {
              name: "市场",
              val: "",
              num: "1"
            }
          ]
        },
        {
          name: "生活",
          val: "",
          list: [
            {
              name: "银行",
              val: "",
              num: "1"
            },
            {
              name: "ATM",
              val: "",
              num: "1"
            }
          ]
        },
        {
          name: "娱乐",
          val: "",
          list: [
            {
              name: "公园",
              val: "",
              num: "1"
            },
            {
              name: "电影院",
              val: "",
              num: "1"
            },
            {
              name: "KTV",
              val: "",
              num: "1"
            }
          ]
        }
      ],
      //搜索周边value
      peripheryVal: "交通",
      peripheryVal2: "地铁",
      map: {},
      position: {},
      labelStyle:{color: 'red', fontSize : '24px'},
      circlePath: {
        center: { },
        radius: ""
      },
    };
  },
  props: ["latitudeVal","dictName"],
  components: {
  },
  created() {
     
  },
  mounted() {
  },
  methods: {
    //创建地图
    handler({ BMap, map }) {
      let _this = this;
      _this.map = map;
      // map.centerAndZoom("成都"); //设置中心点
      //添加缩略图控件
      map.addControl(
        new BMap.OverviewMapControl({
          isOpen: false,
          anchor: BMAP_ANCHOR_BOTTOM_RIGHT
        })
      );
      //添加缩放平移控件
      map.addControl(new BMap.NavigationControl());
      //添加比例尺控件
      map.addControl(new BMap.ScaleControl());
      this.getPeriphery(this.peripheryVal2);
    },
    //地图添加标记
    setMaker() {
      if (this.latitudeVal) {
        this.position = {
          lng: this.latitudeVal.split(",")[0],
          lat: this.latitudeVal.split(",")[1]
        };
        var myIcon = new BMap.Icon("/static/img/map/map-bj1.png", new BMap.Size(37, 54));      
        let point = new BMap.Point(this.position.lng, this.position.lat);
        let marker = new BMap.Marker(point, {
            icon: myIcon
        });
        marker.setAnimation(BMAP_ANIMATION_BOUNCE);
        var opts = {
        position: new BMap.Point(this.position.lng, this.position.lat), // 指定文本标注所在的地理位置
        offset: new BMap.Size(0, -30), // 设置文本偏移量
        labelStyle: {color: 'red', fontSize : '24px'}
        };
        var lable=new BMap.Label(this.dictName, opts )
        marker.setLabel(lable)
        this.map.addOverlay(marker);
        this.map.centerAndZoom(point, 16);
      }
    },
     //地图添加标记
    setCircle() {
      if (this.latitudeVal) {
        this.position = {
          lng: this.latitudeVal.split(",")[0],
          lat: this.latitudeVal.split(",")[1]
        }; 
        let point = new BMap.Point(this.position.lng, this.position.lat);
        let circle = new BMap.Circle(point, 700, {
        strokeColor: 'red',
        strokeWeight: 1,
        strokeOpacity: 0.5,
        fillOpacity:0.3,
        fillColor:"red" 
        })
        this.map.addOverlay(circle);
        this.map.centerAndZoom(point, 16);
      }
    },
    //获取周边并标记地图
    getPeriphery(val) {
      let _this = this;
      this.map.clearOverlays();
      this.setMaker();
      this.setCircle();
      if (val != "") {
        let point = new BMap.Point(this.position.lng, this.position.lat);
        let local = new BMap.LocalSearch(_this.map, {
          renderOptions: {
            map: _this.map,
            panel: "BMapresults",
            autoViewport:false,
            selectFirstResult:false
          }
        });
        local.searchNearby(val, point, 700);
      }
    },
    delete() {
      var overlays = this.map.getOverlays();
      for (var i = 0; i < overlays.length; i++) {
        if (overlays[i].getTitle() == name) {
          this.map.removeOverlay(overlays[i]);
        }
      }
    },

    handleClick(val) {
      this.peripheryVal2 = this.peripheryMenu[Number(val.index)].list[0].name;
      this.keyword= this.peripheryMenu[Number(val.index)].list[0].name;
      this.getPeriphery(this.peripheryVal2);
    },
    handleClick2(val) {
      this.getPeriphery(this.peripheryVal2);
    },
  },
  computed: {},
   watch: {
    latitudeVal() {
      this.setMaker(),
      this.setCircle(),
      this.getPeriphery(this.peripheryVal2);

    },
   }
};
</script>
<style  lang="scss">
.bm-view {
  width: 100%;
  height: 500px;
}
#BMapresults {
  width: 100%;
  height: 376px;
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/baiduMapView.vue